import initialConfigs from './initialConfigs'
import initialTheme from './initialTheme'
import { actions, mutations } from './mutationActions'

const state = {
  reloadCashier: 0,
  config: {
    ...initialConfigs()
  },
  extraConfigs: {},
  extraCustomCSS: '',
  cashierType: 'Standard flow',
  checkoutClient: false,
  theme: {
    ...initialTheme()
  },
  customCss: '',
  autoProcessProvider: 'trustly',
  cashierSpinner: 'spinner',
  countries: [
    {
      country: 'Sweden',
      userId: 'PayTestSE'
    },
    {
      country: 'Finland',
      userId: 'PayTestFI'
    },
    {
      country: 'Norway',
      userId: 'PayTestNO'
    },
    {
      country: 'UK',
      userId: 'PayTestGB'
    },
    {
      country: 'US',
      userId: 'PayTestUS'
    },
    {
      country: 'Germany',
      userId: 'PayTestDE'
    },
    {
      country: 'Denmark',
      userId: 'PayTestDK'
    }
  ]
}

export default {
  state,
  mutations,
  actions
}
